import axios from "../../../utils/axiosConfig.js";
import moment from "moment";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { API_DATE_FORMAT } from "../../../app_constants.js";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";
export const FETCH_MEMBERSHIP_ATTRITION_RATE = "saga/FETCH_MEMBERSHIP_ATTRITION_RATE";
export const FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS =
  "saga/FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS";
export const FETCH_MEMBERSHIP_ATTRITION_RATE_FAILURE =
  "saga/FETCH_MEMBERSHIP_ATTRITION_RATE_FAILURE";
export const FETCH_MEMBERSHIP_ACTIVITY_REVENUE = "saga/FETCH_MEMBERSHIP_ACTIVITY_REVENUE";
export const FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS =
  "saga/FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS";
export const FETCH_MEMBERSHIP_ACTIVITY_REVENUE_FAILURE =
  "saga/FETCH_MEMBERSHIP_ACTIVITY_REVENUE_FAILURE";
export const FETCH_MEMBERSHIP_ACTIVITY_TOTALS = "saga/FETCH_MEMBERSHIP_ACTIVITY_TOTALS";
export const FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS =
  "saga/FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS";
export const FETCH_MEMBERSHIP_ACTIVITY_TOTALS_FAILURE =
  "saga/FETCH_MEMBERSHIP_ACTIVITY_TOTALS_FAILURE";
export const FETCH_MEMBERSHIP_ACTIVITY_VALUES = "saga/FETCH_MEMBERSHIP_ACTIVITY_VALUES";
export const FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS =
  "saga/FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS";
export const FETCH_MEMBERSHIP_ACTIVITY_VALUES_FAILURE =
  "saga/FETCH_MEMBERSHIP_ACTIVITY_VALUES_FAILURE";
export const FETCH_SALES_ACTIVITY_REVENUE = "saga/FETCH_SALES_ACTIVITY_REVENUE";
export const FETCH_SALES_ACTIVITY_REVENUE_SUCCESS = "saga/FETCH_SALES_ACTIVITY_REVENUE_SUCCESS";
export const FETCH_SALES_ACTIVITY_REVENUE_FAILURE = "saga/FETCH_SALES_ACTIVITY_REVENUE_FAILURE";
export const FETCH_INTROS_BOOKED = "saga/FETCH_INTROS_BOOKED";
export const FETCH_INTROS_BOOKED_SUCCESS = "saga/FETCH_INTROS_BOOKED_SUCCESS";
export const FETCH_INTROS_BOOKED_FAILURE = "saga/FETCH_INTROS_BOOKED_FAILURE";
export const FETCH_BAR_CHART = "saga/FETCH_BAR_CHART";
export const FETCH_BAR_CHART_SUCCESS = "saga/FETCH_BAR_CHART_SUCCESS";
export const FETCH_BAR_CHART_FAILURE = "saga/FETCH_BAR_CHART_FAILURE";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const SET_FILTERS_DIRTY = "sagas/SET_FILTERS_DIRTY";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateDates: createAction(UPDATE_DATES)
};

export default function* watchStudio() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

  // Default to MTD
  const endDate = data.payload.calendarEndDate;

  const startDate = moment(endDate).startOf("month").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });

  const commonParams = yield select((state) => {
    let { organization_id, short_url } = state.commonReducer.commonProps;
    return { organization_id, short_url };
  });

  const params = {
    ...commonParams,
    start_date: startDate,
    end_date: endDate
  };

  const allSagas = [
    getMembershipAttritionRate(params),
    getMembershipActivityTotals(params),
    getMembershipActivityValues(params),
    getSalesActivityRevenue(params),
    getIntrosBooked(params),
    getSalesActivityBarChartValues(params),
    getMembershipActivityRevenue(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const params = yield select((state) => {
    let {
      selectedRequestDates: { startDate, endDate }
    } = state.studioInfo;

    return {
      organization_id: organization_id.toString(),
      short_url,
      start_date: startDate,
      end_date: endDate
    };
  });

  const allSagas = [
    getMembershipAttritionRate(params),
    getMembershipActivityTotals(params),
    getMembershipActivityValues(params),
    getSalesActivityRevenue(params),
    getIntrosBooked(params),
    getSalesActivityBarChartValues(params),
    getMembershipActivityRevenue(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getMembershipAttritionRate(params) {
  try {
    const response = yield call(axios.post, "reports/studio_info/attrition_rate/values", params);

    yield put({ type: FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ATTRITION_RATE_FAILURE, error });
  }
}

export function* getMembershipActivityRevenue(params) {
  try {
    const response = yield call(
      axios.post,
      "reports/studio_info/membership_revenues/values",
      params
    );

    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_REVENUE_FAILURE, error });
  }
}

export function* getMembershipActivityTotals(params) {
  try {
    const response = yield call(axios.post, "reports/studio_info/eft_revenue/values", params);

    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_TOTALS_FAILURE, error });
  }
}

export function* getMembershipActivityValues(params) {
  try {
    const response = yield call(axios.post, "reports/studio_info/members/values", params);

    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_ACTIVITY_VALUES_FAILURE, error });
  }
}

export function* getSalesActivityRevenue(params) {
  try {
    const response = yield call(axios.post, "reports/studio_info/sales_revenues/values", params);

    yield put({ type: FETCH_SALES_ACTIVITY_REVENUE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_SALES_ACTIVITY_REVENUE_FAILURE, error });
  }
}

export function* getIntrosBooked(params) {
  try {
    const response = yield call(
      axios.post,
      "reports/studio_info/funnel_laser_chart/values",
      params
    );

    yield put({ type: FETCH_INTROS_BOOKED_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_INTROS_BOOKED_FAILURE, error });
  }
}

export function* getSalesActivityBarChartValues(params) {
  try {
    const response = yield call(axios.post, "reports/studio_info/chart_value/values", params);

    yield put({ type: FETCH_BAR_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_BAR_CHART_FAILURE, error });
  }
}
